import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['spinner', 'button'];

  showSpinner() {
    this.element.classList.add('removing')
  }
}
